import { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersDrawer } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';

import { InviteUser } from '../../../Invitations/components/InviteUser';
import { useFilters } from '../FiltersState';

import { FiltersEntity } from './FiltersEntity';
import { FiltersRole } from './FiltersRole';

export const MobileFilters = () => {
  const { t } = useLingui();
  const [isOpen, setIsOpen] = useState(false);
  const { search, activeFiltersCount, clearFilters } = useFilters();

  return (
    <Stack row gap="1rem" alignItems="center">
      <InputSearch
        ariaLabel={t({
          id: 'settings.organization.members.users.search.label',
          message: 'Search users',
        })}
        placeholder={t({
          id: 'settings.organization.members.users.search.placeholder',
          message: 'Search users...',
        })}
        value={search.search}
        onChange={search.debouncedSetSearch}
        style={{ flex: 1 }}
      />
      <InviteUser />
      <FiltersDrawer
        button={<FiltersButton count={activeFiltersCount} onClick={() => setIsOpen(true)} />}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        onClearFilters={activeFiltersCount ? clearFilters : undefined}
      >
        <FiltersRole />
        <FiltersEntity />
      </FiltersDrawer>
    </Stack>
  );
};
